export const getAction = (store, mutation) => {
    return store + "/" + mutation
}
